// Legacy EPG responses use Landscape; newer responses use HorizontalHigh.
export const getProgramPosterUrl = (posters) => {
  if (!Array.isArray(posters)) return undefined;
  const poster = posters.find((item) => item &&
    ["HorizontalHigh", "Landscape"].includes(item.type || item.posterType) &&
    (item.url || item.posterUrl));
  return poster && (poster.url || poster.posterUrl);
};
